/**
 * We are using axios as our api layer. Each api should return the axios Promise,
 * then within the specific redux action, use the then() methods to
 * dispatch() the specific action for the UI to handle.
 * https://github.com/axios/axios
 * */
import axios from 'axios';

import {
    ENVIRONMENT,
    FORGOT_PIN,
    LOGIN,
    LOGOUT,
    DOB_VERIFY,
    NAME_VERIFY,
    CONVERSATION_DETAILS_GET,
    SAVE_PIN,
    SESSION_TIME,
    CONVERSATION_DETAILS_GET_AFTER_LOGIN,
} from "../constants/ApiEndpoints";


export default class SessionApi {
    static getConversationDetails = conversationHash => axios.get(`${CONVERSATION_DETAILS_GET}/${conversationHash}`);

    static getConversationDetailsAfterLogin = conversationHash => axios.get(`${CONVERSATION_DETAILS_GET_AFTER_LOGIN}/${conversationHash}`);

    static getEnvironment = () => axios.get(ENVIRONMENT);

    static getSessionTime = () => axios.get(SESSION_TIME);

    static login = request => axios.post(LOGIN, request);

    static logout = () => axios.post(LOGOUT);

    static resetForgottenPIN = conversationHash => axios.post(FORGOT_PIN, conversationHash);

    static savePIN = request => axios.post(SAVE_PIN, request);

    static verifyDOB = request => axios.post(DOB_VERIFY, request);

    static verifyName = request => axios.post(NAME_VERIFY, request);
}


